import { useState, useEffect, useCallback } from 'react'
import type { HistoryStats } from '../types/history'
import { getHistoryStats } from '../services/history'

interface UseHistoryStatsResult {
  stats: HistoryStats | null
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useHistoryStats(caseId: string | undefined): UseHistoryStatsResult {
  const [stats, setStats] = useState<HistoryStats | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(async () => {
    if (!caseId) {
      setStats(null)
      setError(null)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const result = await getHistoryStats(caseId)
      setStats(result)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch history stats')
      setStats(null)
    } finally {
      setLoading(false)
    }
  }, [caseId])

  useEffect(() => {
    void fetchData()
  }, [fetchData])

  return { stats, loading, error, refetch: fetchData }
}
